import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-questionaire-radio',
  templateUrl: './questionaire-radio.component.html',
  styleUrl: './questionaire-radio.component.sass'
})
export class QuestionaireRadioComponent {

  @Input()
  options: any[];
  selected:any;
  @Output()
  valSelected = new EventEmitter<any>();

  constructor(){}

  valueSelected(e) {
    this.valSelected.emit(this.selected);
  }

}
